const conf = {
  project: "core" as const,
};

export default conf;
